import { render } from "./Team_manager_adviser.vue?vue&type=template&id=a1cc1138&scoped=true"
import script from "./Team_manager_adviser.vue?vue&type=script&lang=js"
export * from "./Team_manager_adviser.vue?vue&type=script&lang=js"

import "./Team_manager_adviser.vue?vue&type=style&index=0&id=a1cc1138&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a1cc1138"

export default script